import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const Container = styled.div`
  padding: 32px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  background: ${(props) => props.theme.color.blue.default};
  scroll-margin-top: 100px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const ImageContainer = styled.div`
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);

  ${mediaQuery(BREAKPOINTS.tablet)} {
    display: none;
  }

  img {
    height: 100%;
    max-width: 300px;
    object-fit: contain;
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 24px;
  color: ${(props) => props.theme.color.light.default};
  ${mediaQuery(BREAKPOINTS.phone)} {
    text-align: center;
  }
`;

export const Text = styled.div`
  font-weight: 500;
  font-size: 14px;
  margin-top: 8px;
  max-width: 400px;
  text-align: center;
  color: ${(props) => props.theme.color.light.default};
`;

export const FormContainer = styled.div`
  margin-top: 12px;
  max-width: 500px;
`;

export const FormContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  ${mediaQuery(BREAKPOINTS.tablet)} {
    flex-direction: column;
    gap: 0;
  }
`;

export const ImageLeft = styled.div`
  position: absolute;
  left: -32px;

  ${mediaQuery(BREAKPOINTS.tablet)} {
    top: 32px;
  }
`;

export const FormInputs = styled.div`
  width: 100%;
`;

export const FormButton = styled.div`
  text-align: center;

  ${mediaQuery(BREAKPOINTS.tablet, 'min')} {
    flex: 1;
  }
`;

export const TermsContainer = styled.span`
  color: ${(props) => props.theme.color.light.default};
  a {
    color: ${(props) => props.theme.color.blue.lightBlue};
  }
`;
